import { Component, Input } from '@angular/core';

@Component({
  selector: 'aas-number-value',
  templateUrl: './number-value.component.html'
})
export class NumberValueComponent {

  @Input() id: string;
  @Input() value: string;

  constructor() { }
}
